import React, { Component } from "react";
import { connect } from "react-redux";
import { changeRegModeAction } from "../../redux/app/actions";
import { openSwAction } from "../../redux/ui/actions";
import {
  changeDsAction,
  delDsAction,
  changeSelRowAction,
  isDelAction,
} from "../../redux/csLine/actions";
import {
  delDsAction as delDsRsltCsAction,
  changeCsLineAction,
} from "../../redux/csDsp/actions";
import Sw from "../common/Sw";
import Table from "../common/Table";
import Main from "./Main";

const mapStateToProps = (state) => {
  return {
    ds: state.csLineReducer.dataset,
    selRow: state.csLineReducer.selRow,
    isDel: state.csLineReducer.isDel,
  };
};

const tData = [
  { ID: "ID", text: "ID", class: "tsS", abbre: null },
  { ID: "name", text: "名称", class: null, abbre: 50 },
];

class List extends Component {
  constructor(props) {
    super(props);
    this.openSw = this.openSw.bind(this);
    this.delDs = this.delDs.bind(this);

    this.props.dispatch(changeSelRowAction(null));
  }

  componentDidUpdate(prevProps) {
    /*
     * 削除時データセットID・断面ライン名を修正
     * @since hara 2020-10-05
     */
    if (prevProps.ds !== this.props.ds && this.props.isDel) {
      const ds = [...this.props.ds];
      ds.forEach((el, index) => {
        window.setCsLineName(el.ID, index + 1);
        el.ID = index + 1;
      });

      this.props.dispatch(changeDsAction(ds));
      this.props.dispatch(isDelAction(false));
    }
  }

  /*
   * サブウィンドウを開く
   * @param {Number} mode 0=新規/1=編集
   * @since hara 2020-10-05
   */
  openSw(mode) {
    if (mode === 1 && this.props.selRow === null) return; //編集で行未選択の場合
    if (mode === 0 && this.props.ds.length >= 5) {
      alert("断面予測位置は10つまで作成できます。");
      return;
    }

    this.props.dispatch(openSwAction("csLine"));
    this.props.dispatch(changeRegModeAction(mode));
  }

  /*
   * データセット削除
   * @since hara 2020-10-05
   */
  delDs() {
    if (this.props.selRow !== null) {
      const answer = window.confirm(
        "選択したデータセットを削除してもよろしいですか。"
      );
      if (answer) {
        this.props.dispatch(delDsAction(this.props.selRow));
        this.props.dispatch(delDsRsltCsAction(this.props.selRow));
        this.props.dispatch(isDelAction(true));
        this.props.dispatch(changeCsLineAction(0));
        window.delCsLine(this.props.selRow + 1);
      }
    }
  }

  render() {
    return (
      <div>
        <div className="l-row">
          <button className="sBtn" onClick={() => this.openSw(0)}>
            新規
          </button>
          <button className="sBtn l-mlS" onClick={() => this.openSw(1)}>
            修正
          </button>
          <button className="sBtn l-mlS" onClick={this.delDs}>
            削除
          </button>
        </div>

        <Table
          class="TWrap l-mtS"
          tData={tData}
          ds={this.props.ds}
          action={changeSelRowAction}
          isDel={this.props.isDel}
          selRow={this.props.selRow}
        />
      </div>
    );
  }
}

export default connect(mapStateToProps)(List);
